import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "..";
import { IBaseResponse, IWaitListImportColumnMapping, IWaitlistImportItem, IWaitlistImportResults, IWaitListImportSampleRow } from '@nkr/models/index';

export interface IWaitlistImportUploadResponse {
    data: {
        success: boolean,
        results: {
            headers: string[],
            sampleRows: IWaitListImportSampleRow[],
            columnMapping: IWaitListImportColumnMapping[],
            fileName: string
        }
    }
}

export interface IWaitlistImportProcessResponse {
    data: {
        success: boolean,
        results: IWaitlistImportResults
    }
}

export const ActionCreators = {
    uploadWaitlistImportFile: (centerId: number, hasColumnHeaders: boolean, file: File) => async (dispatch: Dispatch<IApplicationState>): Promise<IWaitlistImportUploadResponse> => {
        let formData = new FormData();
        formData.append('centerId', centerId.toString());
        formData.append('hasColumnHeaders', hasColumnHeaders.toString());
        formData.append('file', file);

        var options = {
            url: `${__API__}/recipient/waitlist/upload`,
            data: formData
        };

        return await dispatch(AuthActionCreators.apiPostFormData(options));
    },
    processWaitlistImportFile: (centerId: number, hasColumnHeaders: boolean, autoOrderCheekSwabs: boolean, patientsNotInFile: number, existingMatch: number, mappedFields: string[], fileName: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IWaitlistImportProcessResponse> => {
        var options = {
            url: `${__API__}/recipient/waitlist/process`,
            data: {
                centerId,
                hasColumnHeaders,
                autoOrderCheekSwabs,
                patientsNotInFile,
                existingMatch,
                mappedFields,
                fileName
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    applyWaitlistImportFile: (centerId: number, items: IWaitlistImportItem[], autoOrderCheekSwabs: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/recipient/waitlist/apply`,
            data: {
                centerId,
                items,
                autoOrderCheekSwabs
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
}